import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const PAGES_QUERY = ["site-pages"];

export function usePages() {
  const { data, isSuccess } = useQuery({
    queryKey: PAGES_QUERY,
    queryFn: () => api.get("/pages").then((r) => (Array.isArray(r.data) ? r.data : [])),
    staleTime: 60_000,
  });
  const pages = data ?? [];
  return {
    pages,
    loaded: isSuccess,
    menu: pages.filter((p) => p.in_menu && !p.hidden),
    bySlug: (slug) => pages.find((p) => p.slug === slug),
    isHidden: (path) => pages.some((p) => p.hidden && p.path === path),
  };
}
